import styled from 'styled-components';

export const UnorderedList = styled.ul`
	margin: 0 0 20px;
	list-style: none;
	padding: 0;

	li {
		margin-bottom: 0.75em;
		line-height: 1.5em;
		padding-left: 1em;
		position: relative;
	}

	li::before {
		content: '•';
		color: #90a4ae;
		font-size: 1em;
		height: 100%;
		display: block;
		position: absolute;
		left: 0;
		top: initial;
	}
`;
